// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fillTemplateString } from '../../utils/json-helpers';
import { getRouteTFunction } from '../../i18n';

type Props = {
  bannerKey: string,
  bodyParams: ?[string],
  titleParams: ?[string],
  onClose: ?(evt: Event) => void,
  children: any
}

const AppBanner = ({ bannerKey, bodyParams, titleParams, onClose } : Props) => {
  const { t } = useTranslation('banners');
  const banner = t(bannerKey, { returnObjects: true });
  const routesTFunction = getRouteTFunction();

  if (banner) {
    return (
      <div className={`banner ${bannerKey} ${banner.type}`}>
        <div className='banner__container'>
          <p className='banner__body'>
            <i className={'icon ic-error'} />
            <span className='banner__title'>{fillTemplateString(banner.title, titleParams)}</span>
            <span className='banner__content'>{fillTemplateString(banner.body, bodyParams)}</span>
          </p>
          {banner.linkText && banner.linkUrl && <Link to={routesTFunction(`redirectPaths.${banner.linkUrl}`)}>
            {banner.linkText}
          </Link>}
          {onClose ? <span className='delete' onClick={onClose} role='button' tabIndex={0} /> : ''}
        </div>
      </div>
    );
  }
  return <div />;
};

AppBanner.defaultProps = {
  bodyParams: [],
  titleParams: []
};

export default AppBanner;



// WEBPACK FOOTER //
// ./src/components/shared/AppBanner.js